export const fileSize = (node) => {
    const maxSize = 50000000;

    // Get file size in bytes
    const fileSize = node.value[0].file.size;

    // Compare and return result
    return fileSize < maxSize;
}
